/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getZone = /* GraphQL */ `query GetZone($zoneId: String!) {
  getZone(zoneId: $zoneId) {
    zoneId
    title
    branding
    blocks {
      zoneId
      blockId
      blockType
      index
      accessLevel
      writeAccessLevel
      groups
      options
      data
      interactions {
        items {
          blockId
          interactionKey
          data
          participantId
          timestamp
          expires
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    participants {
      items {
        zoneId
        participantId
        username
        groups
        authenticated
        active
        __typename
      }
      nextToken
      __typename
    }
    participation {
      zoneId
      participantId
      username
      groups
      authenticated
      active
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.GetZoneQueryVariables, APITypes.GetZoneQuery>;
export const getBlock = /* GraphQL */ `query GetBlock($zoneId: ID!, $blockId: ID!) {
  getBlock(zoneId: $zoneId, blockId: $blockId) {
    zoneId
    blockId
    blockType
    index
    accessLevel
    writeAccessLevel
    groups
    options
    data
    interactions {
      items {
        blockId
        interactionKey
        data
        participantId
        timestamp
        expires
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.GetBlockQueryVariables, APITypes.GetBlockQuery>;
export const getCurrentUser = /* GraphQL */ `query GetCurrentUser {
  getCurrentUser {
    userId
    joinedAt
    username
    email
    avatar
    zoneParticipation {
      zone {
        zoneId
        title
        branding
        __typename
      }
      participant {
        zoneId
        participantId
        username
        groups
        authenticated
        active
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCurrentUserQueryVariables,
  APITypes.GetCurrentUserQuery
>;
export const isPushSubscriptionRegistered = /* GraphQL */ `query IsPushSubscriptionRegistered(
  $zoneId: String
  $pushSubscription: String!
) {
  isPushSubscriptionRegistered(
    zoneId: $zoneId
    pushSubscription: $pushSubscription
  )
}
` as GeneratedQuery<
  APITypes.IsPushSubscriptionRegisteredQueryVariables,
  APITypes.IsPushSubscriptionRegisteredQuery
>;
